// extracted by mini-css-extract-plugin
module.exports = {"root":"loading-dots_root__oJRsO","dot":"loading-dots_dot__2W2Uy","blink":"loading-dots_blink__1uFlG"};